var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-wizard',_vm._g(_vm._b({ref:"wizard",attrs:{"data-test-name":_vm.dataTestName},on:{"on-cancel":_vm.onCancel}},'default-wizard',_vm.$attrs,false),_vm.$listeners),[_vm._t("default"),_c('template',{slot:"info"},[_vm._t("info")],2),_c('template',{slot:"extra-actions"},[_vm._t("extra-actions")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }